export const FIREAPP_ACTIONS = {
  SET_INCIDENT_LOCATION: "SET_INCIDENT_LOCATION",
  SET_INCIDENT_LATLNG: "SET_INCIDENT_LATLNG",
  SET_INCIDENT_ADDRESS: "SET_INCIDENT_ADDRESS",
  SET_INCIDENT_DATA: "SET_INCIDENT_DATA",
  SET_ONLINE_USERS: "SET_ONLINE_USERS",
  TOGGLE_SLOW_LINK: "TOGGLE_SLOW_LINK"
};
